import firebase from 'firebase'

var config = {
  apiKey: "AIzaSyDbzyMnKooyMXo3X-bmtST5MWOtPj_2lAs",
  authDomain: "compassion-thevillage.firebaseapp.com",
  databaseURL: "https://compassion-thevillage.firebaseio.com",
  storageBucket: "compassion-thevillage.appspot.com",
  messagingSenderId: "91968174977"
};

var Database = firebase.initializeApp(config);

export default Database;



// WEBPACK FOOTER //
// ./src/components/database.js